export default __webpack_public_path__ + "static/media/all-operational.f84eebe1.svg";